import { IReducer } from '../interface';
import { IInitalState } from './interface';
import * as TYPES from './type';

const initialState: IInitalState = {
    loading: true,
    menu: [],
}

export const menuReducer = (state: IInitalState, { type, payload }: IReducer) => {
    state = state || initialState;
    switch (type) {
        case TYPES.INVALID_PAYLOAD:
        case TYPES.MENU_REQ:
            return state;
        case TYPES.MENU_SUCCESS:
            return {
                ...state,
                loading: false,
                menu: payload
            };
        case TYPES.MENU_FAIL:
            return {
                ...initialState,
                loading: true,
            }
        default:
            return state;
    }
}